import { render } from "./ConfiguracionAliado.vue?vue&type=template&id=50c35add&scoped=true&ts=true"
import script from "./ConfiguracionAliado.vue?vue&type=script&lang=ts"
export * from "./ConfiguracionAliado.vue?vue&type=script&lang=ts"

import "./ConfiguracionAliado.vue?vue&type=style&index=0&id=50c35add&scoped=true&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c35add"]])

export default __exports__